import type { SVGProps } from 'react';

interface LongRightArrowIconProps extends SVGProps<SVGSVGElement> {
    color?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
}

const LongRightArrowIcon = ({
    color = 'currentColor',
    width = 87,
    height = 22,
    className,
    ...props
}: LongRightArrowIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 87 22"
            fill="none"
            className={className}
            {...props}
        >
            <path d="M74.0901 0.644683L85.2697 10.8927L74.0901 21.1406" stroke={color} strokeWidth="1.75" />
            <path d="M83.0389 10.8906L0 10.8906" stroke={color} strokeWidth="2" />
        </svg>
    );
};

export default LongRightArrowIcon;
